import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APP_CONFIGURATION_TOKEN } from '../app-configuration';
import { IUserRepository } from './Iuser.repository';
import { ApiResponse, UserLastSignIn, UserProfile } from './models';


@Injectable({ providedIn: 'root' })
export class UserRepository implements IUserRepository {

	private readonly httpClient = inject(HttpClient);
	private readonly configs = inject(APP_CONFIGURATION_TOKEN);


	getUserGuid(username: string): Observable<ApiResponse<string>> {
		const params = new HttpParams().set('username', username);
		return this.httpClient.get<ApiResponse<string>>(this.configs.domainUserAPI + '/api/users/GetUserGuid', { params });
	}
	getUserProfile(): Observable<ApiResponse<UserProfile>> {
		return this.httpClient.get<ApiResponse<UserProfile>>(this.configs.domainUserAPI + '/api/users/GetUserProfile');
	}
	getLastSignIn(userId: string): Observable<ApiResponse<UserLastSignIn>> {
		const params = new HttpParams().set('userId', userId);
		return this.httpClient.get<ApiResponse<UserLastSignIn>>(this.configs.domainUserAPI + '/api/users/LastSignIn', { params });
	}
	changeLanguage(languageCode: string): Observable<ApiResponse<void>> {
		const headers = new HttpHeaders().set('Content-Type', 'application/json');
		return this.httpClient.patch<ApiResponse<void>>(this.configs.domainUserAPI + '/api/users/ChangeUserLanguage', `"${languageCode}"`, { headers });
	}
	getLanguages(): Observable<ApiResponse<string[]>> {
		return this.httpClient.get<ApiResponse<string[]>>(this.configs.domainUserAPI + '/api/users/GetLanguages');
	}
	getApplicationUrl(): Observable<ApiResponse<string>> {
		return this.httpClient.get<ApiResponse<string>>(this.configs.domainUserAPI + '/api/users/ApplicationUrl');
	}
}
